import { MappingMetadata } from '../hooks/queries/mappings/types';
import { ClientDataType, FieldType } from '../types';

export const getFieldTypeFromFieldMappings = (
  field: string,
  mappings: MappingMetadata[] = [],
  dataType?: ClientDataType,
) =>
  mappings.find(({ name: mappingField, dataType: mappingDataType }) => {
    if (dataType) return field === mappingField && dataType === mappingDataType;
    else return field === mappingField;
  })?.fieldType ?? FieldType.UNDEFINED;
